module.exports = __webpack_public_path__ + "img/uob.6fce13f9.jpg";